export default __webpack_public_path__ + "static/media/TroyMcClure.a2151ad9.png";